<template>
  <div class="h5-container">
    <!-- 登录主体区域 -->
    <div class="login-wrapper">
      <!-- logo + 标题容器：新增小logo区域 -->
      <div class="title-logo-container">
        <!-- 原有大logo -->
        <img
            src="@/assets/img/h5/login_new.png"
            alt="球杆售后系统logo"
            class="system-logo"
        >
        <!-- 新增：三个小logo一行排列容器 -->
        <div class="small-logos-wrap">
          <img src="@/assets/img/h5/U.png" alt="U小logo" class="small-logo">
          <img src="@/assets/img/h5/poison.png" alt="poison小logo" class="small-logo">
          <img src="@/assets/img/h5/guifu.png" alt="guifu小logo" class="small-logo">
        </div>
        <!-- 原有系统标题 -->
        <div class="system-title">球杆售后系统</div>
      </div>

      <!-- 登录方式切换标签 -->
      <van-tabs v-model="activeTab" class="login-tabs" animated swipeable>
        <van-tab title="密码登录" name="password"></van-tab>
        <van-tab title="验证码登录" name="code"></van-tab>
      </van-tabs>

      <!-- 登录表单 -->
      <van-form @submit="onSubmit" class="login-form" ref="loginFormRef">
        <!-- 手机号输入框（公共） -->
        <van-field
            v-model="formData.phoneNumber"
            name="phoneNumber"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            :rules="[{ required: true }, { pattern: mobileReg, message: '请输入正确的手机号' }]"
            clearable
        />

        <!-- 验证码输入框 + 获取验证码按钮（验证码登录专属） -->
        <van-field
            v-if="activeTab === 'code'"
            v-model="formData.code"
            name="code"
            label="验证码"
            placeholder="请输入6位验证码"
            :rules="[{ required: true}, { len: 6, message: '验证码为6位数字' }]"
            clearable
        >
          <template #button>
            <van-button
                size="small"
                type="primary"
                :disabled="countDown > 0 || !isMobileValid"
                @click="getVerifyCode"
                class="code-btn"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </van-button>
          </template>
        </van-field>

        <!-- 密码输入框（密码登录专属，带显隐密码） -->
        <van-field
            v-if="activeTab === 'password'"
            v-model="formData.password"
            name="password"
            label="密码"
            placeholder="请输入6-16位密码"
            type="password"
            :rules="[{ required: true}, { min: 6, max: 16, message: '密码为6-16位字符' }]"
            clearable
            show-password
        />

        <!-- 登录按钮容器 -->
        <div class="login-btn-wrap">
          <van-button
              type="info"
              round
              block
              native-type="submit"
              class="login-btn"
              :loading="isLoading"
          >
            登录
          </van-button>

          <!-- 新增：链接分栏容器 → 实现左/右对齐 -->
          <div class="link-group">
            <!-- 忘记密码：左对齐，仅密码登录显示 -->
            <router-link
                v-if="activeTab === 'password'"
                to="/forgot_password"
                class="activate-link"
            >
              忘记密码
            </router-link>
            <!-- 用户注册：右对齐，始终显示 → 【修改1：恢复为activate-link，加单独的right类】 -->
            <router-link to="/activate_cue" class="activate-link activate-link-right">
              用户注册
            </router-link>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
// 脚本部分完全不变
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import {memberLogin, sendCode} from "@/api/sales";
import {mapActions} from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      activeTab: 'password',
      formData: {
        phoneNumber: "",
        code: "",
        password: ""
      },
      countDown: 0,
      isLoading: false,
      mobileReg: /^1[3-9]\d{9}$/,
      timer: null,
      loginFormRef: null
    };
  },
  computed: {
    isMobileValid() {
      return this.mobileReg.test(this.formData.phoneNumber);
    }
  },
  watch: {
    activeTab(newVal) {
      if (this.loginFormRef) {
        this.loginFormRef.resetValidation();
      }
      if (newVal === 'password') {
        this.formData.code = '';
      } else {
        this.formData.password = '';
      }
    }
  },
  methods: {
    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },
    ...mapActions(['setToken']),

    async getVerifyCode() {
      if (!this.isMobileValid) {
        Toast("请输入正确的手机号");
        return;
      }
      try {
        const res = await sendCode(this.formData.phoneNumber, 'login')
        if (res.code === 200) {
          Toast("验证码已发送，请注意查收");
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.showDialogMsg(res.returnMsg || '获取验证码失败');
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      }
    },

    async onSubmit() {
      this.isLoading = true
      try {
        const loginParams = {
          phoneNumber: this.formData.phoneNumber,
          ...(this.activeTab === 'code'
                  ? {captcha: this.formData.code}
                  : {password: this.formData.password}
          )
        }
        const res = await memberLogin(loginParams);
        if (res.code === 200) {
          this.setToken(res.token)
          Toast.success('登录成功');
          this.$router.replace('/app_home')
        } else {
          Toast(res.returnMsg || '登录失败');
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      } finally {
        this.isLoading = false
      }
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
// 全局容器
.h5-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;

  > * {
    position: relative;
    z-index: 1;
  }
}

// 登录主体包裹层
.login-wrapper {
  width: 100%;
  max-width: 400px;
}

// logo + 标题容器
.title-logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

// 原有大logo样式
.system-logo {
  width: 100%;
  object-fit: contain;
  margin-bottom: 16px;
}

// 小logo容器：样式不变（已修复显示不全）
.small-logos-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 16px;
  background: #FFFFFF;
  padding: 0 10px;
  box-sizing: border-box;
}

// 小logo样式：核心仅修改height为40px（整体缩小，其余不变）
.small-logo {
  height: 40px; // 🔴 关键修改：从60px改40px，整体变小，可按需微调35/45px
  width: auto;
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
  display: block;
  max-width: 100%;
  padding: 0;
}

// 系统标题
.system-title {
  font-size: 24px;
  font-weight: bold;
  color: #D4AF37;
  text-align: center;
  letter-spacing: 2px;
  margin-bottom: 0;
}

// 登录方式切换标签样式
.login-tabs {
  margin-bottom: 12px;

  ::v-deep {
    .van-tabs__wrap {
      background: transparent;
    }

    .van-tab {
      color: #999;
      font-size: 16px;
    }

    .van-tabs__nav {
      background: none;
    }

    .van-tab--active {
      color: #D4AF37;
      font-weight: 500;
    }

    .van-tabs__line {
      background-color: #D4AF37;
      width: 30px;
    }
  }
}

// 登录表单
.login-form {
  background: rgba(26, 26, 26, 0.7);
  padding: 24px;
  border-radius: 12px;
  box-sizing: border-box;
  width: 100%;
}

// 验证码按钮
.code-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
}

// 登录按钮容器
.login-btn-wrap {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 链接分栏容器
.link-group {
  display: flex;
  align-items: center;
  width: 100%;
}

// 基础链接样式
.activate-link {
  color: #D4AF37;
  font-size: 14px;
  text-decoration: none;
  max-width: 100%;

  &:hover {
    color: #B8860B;
    text-decoration: underline;
  }
}
.activate-link-right {
  margin-left: auto;
}

// 登录按钮
.login-btn {
  height: 48px;
  font-size: 16px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: bold;
  width: 100%;
}

// 适配Vant组件样式
::v-deep .van-field__label {
  width: 50px;
  line-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .van-field {
  --van-field-label-color: #fff;
  --van-field-input-color: #fff;
  --van-field-placeholder-color: #999;
  --van-field-border-color: rgba(212, 175, 55, 0.2);
  margin-bottom: 16px;
  border-radius: 10px;
  box-sizing: border-box;
  height: 44px;
  min-height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
}
::v-deep .van-field__control {
  height: 44px;
  line-height: 44px;
  flex: 1;
}
::v-deep .van-field__button {
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  flex-shrink: 0;
}
::v-deep .van-icon-eye-o,
::v-deep .van-icon-eye,
::v-deep .van-field__clear {
  color: #D4AF37;
  line-height: 44px;
}

::v-deep .van-button--info {
  --van-button-info-background: #D4AF37;
  --van-button-info-border-color: #D4AF37;
}
</style>